import { initFrontend } from 'lincd-server-utils/lib/utils/Frontend';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import React, { startTransition } from 'react';
import { AppContextProvider } from 'lincd-server-utils/lib/components/AppContext';
import { ErrorBoundary } from 'react-error-boundary';
import './config-frontend';
import { renderToString } from 'react-dom/server';

function ErrorFallback({ error }: { error: Error }) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
    </div>
  );
}
// console.log(renderToString(<React.StrictMode>
//   <ErrorBoundary FallbackComponent={ErrorFallback}>
//     <BrowserRouter>
//       <AppContextProvider
//         assets={window['assetManifest']}
//         requestLD={document.getElementById('request-ld')?.innerText}
//         requestObject={document.getElementById('request-json')?.innerText}
//       >
//         <App />
//       </AppContextProvider>
//     </BrowserRouter>
//   </ErrorBoundary>
// </React.StrictMode>));

console.log('Hydration starting...');
initFrontend().then(() => {
  startTransition(() => {
    hydrateRoot(
      document,
      <React.StrictMode>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <BrowserRouter>
            <AppContextProvider
              assets={window['assetManifest']}
              requestLD={document.getElementById('request-ld')?.innerText}
              requestObject={document.getElementById('request-json')?.innerText}
            >
              <App />
            </AppContextProvider>
          </BrowserRouter>
        </ErrorBoundary>
      </React.StrictMode>,
      {
        onRecoverableError: (error) => {
          console.error('Recoverable error during hydration:', error);
          // Optionally send the error to a monitoring service
        },
      },
    );
    console.log('Hydration completed.');
  });
});